/**
 * P0.4 first-time-user onboarding wizard shared types.
 *
 * Backend: `apps/api/src/routes/onboarding.ts`.
 * Frontend: `apps/web/src/features/onboarding/`.
 */
import { z } from 'zod';
import { IsoDateTimeSchema, UuidSchema } from './common.js';

export const OnboardingStepSchema = z.enum([
  'create_project',
  'connect_gsc',
  'first_audit',
  'keyword_research',
  'first_track_and_brief',
  'done',
]);
export type OnboardingStep = z.infer<typeof OnboardingStepSchema>;

export const ONBOARDING_STEPS: readonly OnboardingStep[] = [
  'create_project',
  'connect_gsc',
  'first_audit',
  'keyword_research',
  'first_track_and_brief',
  'done',
] as const;

export const OnboardingStateSchema = z.object({
  id: UuidSchema,
  tenant_id: UuidSchema,
  user_id: UuidSchema,
  step: OnboardingStepSchema,
  completed_at: IsoDateTimeSchema.nullable(),
  skipped_steps: z.array(OnboardingStepSchema),
  created_at: IsoDateTimeSchema,
  updated_at: IsoDateTimeSchema,
});
export type OnboardingState = z.infer<typeof OnboardingStateSchema>;

export const AdvanceOnboardingRequestSchema = z.object({
  to_step: OnboardingStepSchema,
});
export type AdvanceOnboardingRequest = z.infer<typeof AdvanceOnboardingRequestSchema>;

export const SkipOnboardingRequestSchema = z.object({
  step: OnboardingStepSchema,
});
export type SkipOnboardingRequest = z.infer<typeof SkipOnboardingRequestSchema>;
